import {Map} from "immutable";
import React from "react";
import Checkbox from "./Checkbox";
import "./PageHeader.css";

const EXPERT_MODE_ID = "advancedMode";
export function isAdvancedMode(routerQuery) {
  return routerQuery[EXPERT_MODE_ID] === "true";
}

function PageHeader(props) {
  const { onBack, title, advancedModeToggle, router } = props;

  let backButton = null;
  if (props.backButton) {
    backButton = <span className="backButton" onClick={onBack} />
  }

  const advancedModeElem = advancedModeToggle && router && (
    <Checkbox
      label="Advanced Mode"
      checked={router.location.query.advancedMode === "true"}
      onClick={() => handleToggleAdvancedMode(router)}
    />
  )

  return (
    <div className="PageHeader">
      <div className="title">{backButton}{title}</div>
      { advancedModeElem }
    </div>
  )
}

function handleToggleAdvancedMode(router) {
  const isAdvanced = isAdvancedMode(router.location.query);
  
  let searchQueries = Map(router.location.query)
  searchQueries = searchQueries.set(EXPERT_MODE_ID, !isAdvanced);

  router.push({
    pathname: router.location.pathname,
    query: searchQueries.toJS()
  });
}

export default PageHeader;


PageHeader.defaultProps = {
  title: "",
  backButton: false
}